"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PrimusChildrenField = props => {
  const registry = props.registry;
  const ArrayField = registry.fields.ArrayField;
  return _react.default.createElement(ArrayField, props);
};

var _default = PrimusChildrenField;
exports.default = _default;
module.exports = exports.default;